import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"

/** @deprecated Please use the `@/modules/format/object/toCamelCaseKeys` module */
export const keysToCamelCase = <T>(object: unknown): T => toCamelCaseKeys<T>(object)
